/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    variant: {
      type: String as PropType<"outlined" | "elevated">,
      required: false,
      default: () => {
        return "outlined";
      },
    },
    disabled: Boolean,
  },
});
